<template>
  <b-modal
    centered
    id="change-supervisor"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Chuyển người tiếp nhận/giám sát</h5>
      <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo" class="m-3">
      <div class="form-group">
        <b-form-checkbox @change="changeOption" v-model="selectedOption" value="RECEIVER">
          <p>Người tiếp nhận ticket</p>
        </b-form-checkbox>
      </div>
      <div class="form-group" v-if="selectedOption === 'RECEIVER'">
        <Select2 v-model="userId" :options="dataOption" placeholder="Chọn user" />
      </div>
      <div class="form-group">
        <b-form-checkbox @change="changeOption" v-model="selectedOption" value="SUPERVISOR">
          <p>Người giám sát ticket</p>
        </b-form-checkbox>
      </div>
      <div class="form-group" v-if="selectedOption === 'SUPERVISOR'">
        <Select2 v-model="userId" :options="dataOptionsUserSupervisor" placeholder="Chọn user" />
      </div>
    </form>
    <template #modal-footer>
      <b-button class="btn-style" size="sm" type="button" variant="light" @click="closeModal()">
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  export default {
    name: 'modal-change-supervisor',
    props: {
      dataOption: {
        type: Array,
        default: [],
      },
      dataOptionsUserSupervisor: {
        type: Array,
        default: [],
      },
      closeModal: {
        type: Function,
      },
    },
    data() {
      return {
        showLoading: false,
        selectedOption: null,
        userId: '',
      }
    },
    methods: {
      async updateInfo() {
        const data = {}
        if (this.selectedOption === 'RECEIVER') {
          data.isUpdateAssignee = true
          data.isUpdateSupervisor = false
          data.assignee = this.userId
          data.supervisor = ''
        } else if (this.selectedOption === 'SUPERVISOR') {
          data.isUpdateSupervisor = true
          data.isUpdateAssignee = false
          data.supervisor = this.userId
          data.assignee = ''
        }
        this.$emit('updateInfo', data)
      },
      changeOption() {
        this.userId = ''
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
  p {
    font-size: 14px;
  }
</style>
